define.alias("shared/modifiers/scroll-to-top", "settings/modifiers/scroll-to-top");